import React, { useState } from 'react';
import { Shield, Menu } from 'lucide-react';
import { FaXTwitter, FaInstagram, FaFacebook, FaYoutube, FaReddit } from 'react-icons/fa6';
import InfoModal from '../Modals/InfoModal';
import './SideMenu.css';

const SideMenu = ({ isOpen, onClose, onOpenProfile, onOpenHelp }) => {
  const [showInfoModal, setShowInfoModal] = useState(null);

  const openModal = (type) => {
    onClose();
    setShowInfoModal(type);
  };

  return (
    <>
      <div className={`side-menu-overlay ${isOpen ? 'active' : ''}`} onClick={onClose}></div>
      <div className={`side-menu ${isOpen ? 'active' : ''}`}>
        <div className="side-menu-content">
          <div className="side-menu-header">
            <button className="side-menu-close" onClick={onClose}>
              <Menu size={28} />
            </button>
            <div className="menu-logo">
              <div className="menu-logo-shield">
                <Shield size={36} />
                <span className="menu-logo-k">K</span>
              </div>
              <span className="menu-logo-text">RIME</span>
            </div>
            <div className="menu-spacer"></div>
          </div>

          <div className="side-menu-divider"></div>

          <div className="side-menu-links">
            <button type="button" onClick={() => onOpenProfile?.()}>Profile</button>
            <div className="side-menu-divider"></div>
            <button type="button" onClick={() => onOpenHelp?.()}>Help</button>
            <div className="side-menu-divider"></div>
            <a href="https://krime.blog" target="_blank" rel="noopener noreferrer" onClick={onClose}>Blog</a>
            <div className="side-menu-divider"></div>
          </div>

          <div className="side-menu-bottom">
            <div className="side-menu-bottom-links">
              <button onClick={() => openModal('disclaimer')}>Disclaimer</button>
              <button onClick={() => openModal('terms')}>Terms of Use</button>
              <button onClick={() => openModal('privacy')}>Privacy Policy</button>
              <button onClick={() => openModal('contact')}>Contact</button>
            </div>

            <div className="side-menu-bottom-social">
              <a href="https://x.com/krimeapp" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                <FaXTwitter size={20} />
              </a>
              <a href="https://youtube.com/@krimeapp" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <FaYoutube size={20} />
              </a>
              <a href="https://instagram.com/krimeapp" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram size={20} />
              </a>
              <a href="https://facebook.com/krimeapp" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook size={20} />
              </a>
              <a href="https://reddit.com/r/krimeapp" target="_blank" rel="noopener noreferrer" aria-label="Reddit">
                <FaReddit size={20} />
              </a>
            </div>

            <p className="side-menu-bottom-copyright">&copy; 2026 KRIME Inc. All rights reserved.</p>
          </div>
        </div>
      </div>

      {showInfoModal && (
        <InfoModal
          type={showInfoModal}
          onClose={() => setShowInfoModal(null)}
        />
      )}
    </>
  );
};

export default SideMenu;
